import React, { useState } from "react";
import "./PrivacyPolicy.css";
import Navbar from "./Navbar";
import Footer from "./Footer"
const sections = [
  {
    number: "01",
    title: "Introduction",
    content: `Welcome to NourTune! Your privacy is our priority. This policy transparently outlines how we handle your information as you use our services.`,
  },
  {
    number: "02",
    title: "Information We Collect",
    content:
      "We collect only what's necessary to provide you with the best experience:",
    list: [
      "Personal information you provide directly (name, email address)",
      "Device and usage data to improve our services",
      "Cookies and similar technologies for personalization",
    ],
  },
  {
    number: "03",
    title: "How We Use Information",
    content: "Your data helps us create a better experience:",
    list: [
      "Deliver and maintain our services seamlessly",
      "Personalize your experience and content",
      "Communicate important updates and offers",
      "Analyze usage patterns to improve our app",
    ],
  },
  {
    number: "04",
    title: "Data Sharing",
    content: "We value your trust:",
    list: [
      "We never sell your personal data",
      "Limited sharing with trusted service providers",
      "Compliance with legal obligations when required",
    ],
  },
  {
    number: "05",
    title: "Security Measures",
    content: `Your data security is paramount. We employ industry-standard encryption and regular security audits to protect your information from unauthorized access.`,
  },
  {
    number: "06",
    title: "Children's Privacy",
    content: `Our services are designed for users 13 and above. We don't knowingly collect data from children under 13 and promptly delete any such information if discovered.`,
  },
  {
    number: "07",
    title: "Your Rights",
    content: "You have control over your data:",
    list: [
      "Access and review your personal information",
      "Request corrections or deletions",
      "Opt-out of non-essential data collection",
      "Export your data anytime",
    ],
  },
  {
    number: "08",
    title: "Policy Updates",
    content: `We may update this policy to reflect improvements in our services. We'll notify you of significant changes through our app or email.`,
  },
  {
    number: "09",
    title: "Contact Us",
    content: "Have questions? We're here to help:",
    email: "support@nourtune.com",
  },
];

const PrivacyPolicy = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="light">
      <div className="privacy-policy-container">
        <div className="privacy-header">
          <h1>Privacy Policy</h1>
          <div className="effective-date">Effective March 3, 2026</div>
        </div>

        <div className="privacy-grid">
          {sections.map((section, index) => (
            <div key={index} className="policy-section">
              <button
                className={`privacy-title ${openIndex === index ? "open" : ""}`}
                onClick={() => toggleSection(index)}
              >
                <div className="title-text">
                  <span className="privacy-number">{section.number}</span>
                  <span>{section.title}</span>
                </div>
                <span className="arrow-icon">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>
              <div
                className={`privacy-content ${openIndex === index ? "open" : ""}`}
              >
                <div className="content-inner">
                  <p>{section.content}</p>
                  {section.list && (
                    <ul className="content-list">
                      {section.list.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.email && (
                    <a
                      href={`mailto:${section.email}`}
                      className="contact-email"
                    >
                      {section.email}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
